import React, { DragEvent as ReactDragEvent, useEffect, useState } from 'react';
import { shallowEqual, useDispatch } from 'react-redux';
import { setDrag } from '../../reducers/drag/dragReducerActions';
import Client from '../../utils/network';
import { TokenStats } from './TokenForm';
import { useSelector } from 'react-redux';
import { Rootstate } from '../../store';
import { CreateTokenModal } from './CreateTokenModal';
import { ObjectId } from 'bson';

function TokenCreator() {
    const dispatch = useDispatch();
    const [insertableTokens, setInsertableTokens] = useState<TokenStats[]>();

    const { layer } = useSelector((state: Rootstate) => ({
        layer: state.map.mainLayer,
    }), shallowEqual);
    const getInsertableTokens = () => {
        Client.request('/api/token').then(async (res) => {
            const body = await res.json() as TokenStats[];
            setInsertableTokens(body);
            return;
        }).catch(err => {
            // eslint-disable-next-line no-console
            console.error(err);
        });
    };

    useEffect(() => {
        getInsertableTokens();
    }, []);

    const startDraggingToken = (e: ReactDragEvent<HTMLImageElement>, token: TokenStats) => {
        e.preventDefault();

        const onDragEnd = () => {
            dispatch(setDrag(false));
            window.removeEventListener('mouseup', onDragEnd);
        };

        window.addEventListener('mouseup', onDragEnd);

        dispatch(setDrag(
            true,
            {
                type: 'move-token',
                details: {
                    token: {
                        rotation: 0,
                        ...token,
                        xScale: 1,
                        yScale: 1,
                        _id: new ObjectId(),
                        xPos: e.clientX,
                        yPos: e.clientY,
                        dm: layer === 'dm',
                    },
                    startX: e.clientX,
                    startY: e.clientY,
                    rotate: 0,
                },
            },
        ));
    };

    return (
        <div className="flex align-center gap-2">
            <div className=" min-h-24 min-w-[600px] bg-deep-blue rounded-2xl">
                <div className='grid grid-flow-col grid-rows-2 p-3 gap-6 w-fit'>
                    {(insertableTokens ?? []).map((token) => {
                        return (
                            <img
                                key={token._id.toString()}
                                className='max-w-12 max-h-12'
                                onDragStart={(e) => startDraggingToken(e, token)}
                                src={`${Client.getBaseUrl()}/api/image/${token.image}/thumbnail`}
                            />
                        );
                    })}
                </div>
            </div>
            <CreateTokenModal loadTokens={getInsertableTokens}  />
        </div>

    );
}
export default TokenCreator;
